import { createSelector } from 'reselect';
import { createInstanceValueSelector } from 'structured-content-lib/redux/selectors/instanceEditSelectors';
import { selectInstanceGroupSlug } from 'structured-content-lib/redux/selectors/instanceGroupSelectors';

// selectors
export const selectInstanceName = createInstanceValueSelector('hs_name');
export const selectInstanceGroupId = createInstanceValueSelector('hs_group_id');
export const selectInstanceId = createInstanceValueSelector('hs_id');
export const selectInstanceDomain = createInstanceValueSelector('hs_domain');
export const selectInstancePath = createInstanceValueSelector('hs_path');
export const selectCaseStudyUrl = createSelector([selectInstanceDomain, selectInstanceGroupSlug, selectInstancePath], (instanceDomain, instanceGroupSlug, instancePath) => `https://${instanceDomain}/${instanceGroupSlug}/${instancePath}`);